import React, { useEffect, useState } from "react";
import Footer from "../../../Kryzen Alpha App/Components//Footer/footer";
import StepRoutes from "../../../Kryzen Alpha App/Routes/steps_routes";
import performRequest from "../../../Kryzen Alpha App/api/request";
import { Toast } from "../../../Kryzen Alpha App/CustomComponent/toast";
import Pagination from "../../../Kryzen Alpha App/Components/layouts/pagination";
import getFilteredURL from "../../../Kryzen Alpha App/Components/Functions/filters.getUrl";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { FcInspection, FcNeutralTrading } from "react-icons/fc";
import { useNavigate } from "react-router";
import LeadMastertable from "./lead_master_table";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import LoadingPage from "../../Components/layouts/loading";

const LeadMasters = () => {
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    lead_stage_status: "",
    name: "",
    // feedbackType: "",
  });
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL(`/leadsMaster/getLeadMaster/`, page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data?.leadsMasters);
          setTotalPages(Math.ceil(res?.data?.totalCount / 50));
        } else {
          Toast("error", "Error while getting leads master!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div style={{ minHeight: "80vh" }}>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row g-2 align-items-center">
                <div className="col-md-8">
                  <h2 className="page-title">
                    <FcNeutralTrading className="fs-2 me-1" />
                    Leads Master
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="container-xxl">
              <div className="row">
                <div className="col-md-3 col-sm-12 py-2">
                  <div className="card p-2">
                    <div
                      id="faq-1"
                      className="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div>
                        <div className="accordion-header m-0" role="tab">
                          <button
                            className="accordion-button fs-3 d-md-none p-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq-1-1"
                          >
                            <h3 className="m-1">Filter result</h3>
                          </button>
                        </div>

                        <div
                          id="faq-1-1"
                          className="accordion-collapse collapse d-md-none"
                          role="tabpanel"
                          data-bs-parent="#faq-1"
                        >
                          <div className="accordion-body pt-0">
                            <div className="row">
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Start Date:"
                                  value={filters.startdate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="End Date:"
                                  value={filters.enddate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      enddate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Name / Mobile"
                                  value={filters.name}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      name: e.target.value,
                                    })
                                  }
                                  type="text"
                                  placeholder="Search name/mobile"
                                />
                              </div>

                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Source Platform"
                                  value={filters.name}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      name: e.target.value,
                                    })
                                  }
                                  type="text"
                                  placeholder="Search name/mobile"
                                />
                              </div>

                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Lead Stage Status:"
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      lead_stage_status: e.target.value,
                                    })
                                  }
                                  value={filters.lead_stage_status}
                                >
                                  <option value="">Select all</option>
                                  <option value="Executive">Executive</option>
                                  <option value="Closer">Closer</option>
                                  <option value="enquiry"> Enquiry</option>
                                </DynamicFilterSelect>
                              </div>

                              <div className="col-12">
                                <div className="row mt-2">
                                  <div className="col-6">
                                    <button
                                      onClick={() => setRefresh(!refresh)}
                                      className="btn btn-success w-100"
                                    >
                                      Apply Filter
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        setFilters({
                                          startdate: "",
                                          enddate: "",
                                          lead_stage_status: "",
                                          name: "",
                                          //   feedbackType: "",
                                        });
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-secondary w-100"
                                    >
                                      Reset Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="accordion-body d-none d-md-block">
                          <div className="row">
                            <h3>Filter result</h3>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Start Date:"
                                value={filters.startdate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    startdate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="End Date:"
                                value={filters.enddate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    enddate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            {/* <div className="col-12">
                              <DynamicFilterSelect
                                label="Feedback type:"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    feedbackType: e.target.value,
                                  })
                                }
                                value={filters.feedbackType}
                              >
                                <option value="">select all</option>
                                <option value="Comments">Comments</option>
                                <option value="Suggestions">Suggestions</option>
                                <option value="Questions">Questions</option>
                                <option value="Other">Other</option>
                              </DynamicFilterSelect>
                            </div> */}
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Name / Mobile"
                                value={filters.name}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    name: e.target.value,
                                  })
                                }
                                type="text"
                                placeholder="Search name/mobile"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Lead Stage Status:"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    lead_stage_status: e.target.value,
                                  })
                                }
                                value={filters.lead_stage_status}
                              >
                                <option value="">Select all</option>
                                <option value="Executive">Executive</option>
                                <option value="Closer">Closer</option>
                                <option value="enquiry"> Enquiry</option>
                              </DynamicFilterSelect>
                            </div>

                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-6">
                                  <button
                                    onClick={() => setRefresh(!refresh)}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      setFilters({
                                        startdate: "",
                                        enddate: "",
                                        lead_stage_status: "",
                                        name: "",
                                        // feedbackType: "",
                                      });
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-9 col-sm-12 py-2">
                  <div className="card">
                    <LeadMastertable
                      data={data}
                      currentPage={page}
                      itemsPerPage={50}
                    />
                    <Pagination
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageDatalength={data?.leadsMasters?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default LeadMasters;
